<template>
<div class="chapter">
<div class="inner_page">
<p>A Caravan book. For more information, visit <a href="http://www.caravanbooks.org" target="_blank">www.caravanbooks.org</a>.<br/><br/></p>
<p>Copyright © 2007 by Yale University.<br/>
All rights reserved.<br/>
This book may not be reproduced, in whole or in part, including illustrations, in any form (beyond that copying permitted by Sections 107 and 108 of the U.S. Copyright Law and except by reviewers for the public press), without written permission from the publishers.<br/><br/></p>
<p>Set in Minion and Franklin Gothic types by The Composing Room of Michigan, Inc. Printed in the United States of America.<br/><br/></p>
<p>Library of Congress Cataloging-in-Publication Data<br/>
Parsi, Trita.<br/>
Treacherous alliance : the secret dealings of Israel, Iran, and the United States /<br/>
Trita Parsi.<br/>
p. cm.<br/>
Includes bibliographical references and index.<br/>
ISBN 978-0-300-12057-8 (hardcover: alk. paper)<br/>
1. Iran—Foreign relations—Israel. 2. Israel—Foreign relations—Iran.<br/>
3. United States—Foreign relations—Middle East. 4. Middle East—<br/>
Foreign relations—United States.   I. Title.<br/>
DS274.2.I75P37 2007<br/>
327.5694055—dc22</p>
<p class="right">2007018945</p>
<p>A catalogue record for this book is available from the British Library.</p>
<p>The paper in this book meets the guidelines for permanence and durability of the Committee on Production Guidelines for Book Longevity of the Council on Library Resources.</p>
<p>10  9  8  7  6  5  4  3  2  1</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03-copyright.vue?8b23011a